import { a as s, A as n, i as f } from "../get-CgQB3NDi.mjs";
function g(e) {
  const t = [...e];
  return t.forEach((u) => {
    delete u.repeatingKey;
  }), t;
}
function o(e) {
  return d(e) ? "Pendo Suggested" : l(e) ? "Inherited" : i(e) ? "Inactive" : c(e) ? "Automatic" : "Custom";
}
function b(e) {
  return s(n(e, "rootVersionId", !1)) && !n(e, "id", "").includes("auto");
}
function i(e) {
  return (e == null ? void 0 : e.kind) === "TrackType" ? !n(e, "trainingSettings.enabled", !1) : !n(e, "trainingSettings.enabled", !1) && !s(n(e, "rootVersionId", !1)) && !n(e, "id", "").includes("auto");
}
function l(e) {
  return (e == null ? void 0 : e.kind) === "TrackType" ? n(e, "trainingSettings.enabled", !1) : n(e, "trainingSettings.enabled", !1) && !s(n(e, "rootVersionId", !1)) && !n(e, "id", "").includes("auto");
}
function d(e) {
  return (n(e, "isSuggested", !1) || n(e, "isAutoTagged", !1)) && f(n(e, "trainingSettings", {})) && !n(e, "id", "").includes("auto");
}
function c(e) {
  return n(e, "id", "").includes("auto");
}
function C(e, t = !1) {
  const u = ["Pendo Suggested", "Automatic", "Custom"], a = ["Custom"], r = o(e);
  return t ? a.includes(r) : u.includes(r);
}
function p(e, t = !1) {
  const u = ["Pendo Suggested", "Inactive", "Automatic", "Custom"], a = ["Custom"], r = o(e);
  return t ? a.includes(r) : u.includes(r);
}
function y(e, t) {
  return t.some((u) => u.name === e);
}
function S({ features: e, originalName: t }) {
  return (u, a, r) => a === "" ? r(new Error("Name is required.")) : a.length > 1500 ? r(new Error("Name cannot exceed 1500 characters.")) : a !== t && y(a, e) ? r(new Error("This feature name is already in use. Try another?")) : r();
}
const T = {
  removeRepeatingKeys: g,
  countableType: o,
  isCustomCountable: b,
  isInheritedCountable: l,
  isInactiveCountable: i,
  isSuggestedCountable: d,
  isAutomaticCountable: c,
  canEditCountable: C,
  canDeleteCountable: p,
  validateFeatureName: S
}, h = {
  ...T
};
export {
  p as canDeleteCountable,
  C as canEditCountable,
  o as countableType,
  h as default,
  c as isAutomaticCountable,
  b as isCustomCountable,
  i as isInactiveCountable,
  l as isInheritedCountable,
  d as isSuggestedCountable,
  g as removeRepeatingKeys,
  S as validateFeatureName
};
